export default [
  {
    path: "/store/setting",
    name: "Setting",
    component: () => import("@/pages/store/setting/Setting.vue"),
    meta: {
      title: "网校设置",
      requireAuth: true,
      authority: "store:setting"
    },
    redirect: "/store/setting/style",
    children: [
      {
        path: "style",
        name: "Style",
        component: () => import("@/pages/store/setting/view/style/Style.vue"),
        meta: {
          title: "店铺风格",
          requireAuth: true,
          authority: "store:setting"
        },
        redirect: "/store/setting/style/preview",
        children: [
          {
            path: "preview",
            name: "Preview",
            component: () =>
              import("@/pages/store/setting/view/style/view/Preview.vue"),
            meta: {
              title: "店铺预览",
              requireAuth: true,
              authority: "store:setting"
            }
          },
          {
            path: "navigation",
            name: "Navigation",
            component: () =>
              import("@/pages/store/setting/view/style/view/Navigation.vue"),
            meta: {
              title: "底部导航",
              requireAuth: true,
              authority: "store:setting"
            }
          },
          {
            path: "color",
            name: "ColorTheme",
            component: () =>
              import("@/pages/store/setting/view/style/view/Color.vue"),
            meta: {
              title: "主题色",
              requireAuth: true,
              authority: "store:setting"
            }
          }
        ]
      },
      {
        path: "storeinfo",
        name: "Storeinfo",
        component: () =>
          import("@/pages/store/setting/view/storeinfo/Storeinfo.vue"),
        meta: {
          title: "店铺信息",
          requireAuth: true,
          authority: "store:setting"
        }
      },
      {
        path: "thirdAccount",
        name: "ThirdAccount",
        component: () =>
          import("@/pages/store/setting/view/thirdAccount/index.vue"),
        meta: {
          title: "第三方平台账号管理",
          requireAuth: true,
          authority: "store:setting"
        }
      }
    ]
  },
  {
    path: "/store/setting/style/navigation/add",
    name: "NavigationRedact",
    component: () =>
      import("@/pages/store/setting/view/style/view/NavigationRedact.vue"),
    meta: {
      title: "新建导航",
      requireAuth: true,
      authority: "store:setting"
    }
  },
  {
    path: "/store/setting/style/navigation/edit",
    name: "NavigationRedact",
    component: () =>
      import("@/pages/store/setting/view/style/view/NavigationRedact.vue"),
    meta: {
      title: "编辑导航",
      requireAuth: true,
      authority: "store:setting"
    }
  },
  {
    path: "/store/category",
    name: "StoreCategoryList",
    component: () => import("@/pages/store/category/List.vue"),
    meta: {
      title: "内容分类",
      requireAuth: true,
      authority: "store:category"
    }
  },
  {
    path: "/store/material",
    name: "StoreMaterial",
    component: () => import("@/pages/store/material/Material.vue"),
    meta: {
      title: "素材管理",
      requireAuth: true,
      authority: "store:material"
    },
    redirect: "/store/material/picture",
    children: [
      {
        path: "picture",
        name: "StoreMaterialPicture",
        component: () => import("@/pages/store/material/view/Picture.vue"),
        meta: {
          title: "图片",
          requireAuth: true,
          authority: "store:material"
        }
      },
      {
        path: "audio",
        name: "StoreMaterialAudio",
        component: () => import("@/pages/store/material/view/Audio.vue"),
        meta: {
          title: "音频",
          requireAuth: true,
          authority: "store:material"
        }
      },
      {
        path: "video",
        name: "StoreMaterialVideo",
        component: () => import("@/pages/store/material/view/Video.vue"),
        meta: {
          title: "视频",
          requireAuth: true,
          authority: "store:material"
        }
      },
      {
        path: "file",
        name: "StoreMaterialFile",
        component: () => import("@/pages/store/material/view/File.vue"),
        meta: {
          title: "文件",
          requireAuth: true,
          authority: "store:material"
        }
      }
    ]
  },
  {
    path: "/store/material/lable",
    name: "Lable",
    component: () => import("@/pages/store/material/view/Lable.vue"),
    meta: {
      title: "标签管理",
      requireAuth: true,
      authority: "store:material"
    }
  },
  {
    path: "/store/merchant",
    name: "StoreMerchant",
    component: () => import("@/pages/store/merchant/index.vue"),
    meta: {
      title: "子店铺",
      requireAuth: true,
      authority: "store:merchant"
    }
  },
  {
    path: "/store/merchant/add",
    name: "StoreMerchantAddOrUpdate",
    component: () => import("@/pages/store/merchant/addOrUpdate.vue"),
    meta: {
      title: "新建子店铺",
      requireAuth: true,
      authority: "store:merchant"
    }
  },
  {
    path: "/store/merchant/edit",
    name: "StoreMerchantAddOrUpdate",
    component: () => import("@/pages/store/merchant/addOrUpdate.vue"),
    meta: {
      title: "编辑子店铺",
      requireAuth: true,
      authority: "store:merchant"
    }
  },
  {
    path: "/store/merchant/detail",
    name: "StoreMerchantDetail",
    component: () => import("@/pages/store/merchant/detail/index.vue"),
    meta: {
      title: "子店铺详情",
      requireAuth: true,
      authority: "store:merchant"
    },
    redirect: "/store/merchant/detail/subtenant",
    children: [
      {
        path: "subtenant",
        name: "StoreMerchantDetailSubtenant",
        component: () =>
          import("@/pages/store/merchant/detail/subtenant/index.vue"),
        meta: {
          title: "子店铺设置",
          requireAuth: true,
          authority: "store:merchant"
        }
      },
      {
        path: "plan",
        name: "StoreMerchantDetailPlan",
        component: () => import("@/pages/store/merchant/detail/plan/index.vue"),
        meta: {
          title: "子店铺套餐",
          requireAuth: true,
          authority: "store:merchant"
        }
      },
      {
        path: "check",
        name: "StoreMerchantDetailCheck",
        component: () =>
          import("@/pages/store/merchant/detail/check/index.vue"),
        meta: {
          title: "课程申请审核",
          requireAuth: true,
          authority: "store:merchant"
        }
      }
    ]
  },
  {
    path: "/store/merchant/detail/check/detail",
    name: "StoreMerchantDetailCheckDetail",
    component: () => import("@/pages/store/merchant/detail/check/detail.vue"),
    meta: {
      title: "课程申请审核详情",
      requireAuth: true,
      authority: "store:merchant"
    }
  },
  {
    path: "/store/apply",
    name: "StoreApply",
    component: () => import("@/pages/store/apply/index.vue"),
    meta: {
      title: "课程申请",
      requireAuth: true,
      authority: "store:apply"
    }
  },
  {
    path: "/store/apply/add",
    name: "StoreApplyAddOrUpdate",
    component: () => import("@/pages/store/apply/addOrUpdate.vue"),
    meta: {
      title: "新建申请",
      requireAuth: true,
      authority: "store:apply"
    }
  },
  {
    path: "/store/apply/edit",
    name: "StoreApplyAddOrUpdate",
    component: () => import("@/pages/store/apply/addOrUpdate.vue"),
    meta: {
      title: "编辑申请",
      requireAuth: true,
      authority: "store:apply"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/module/store.js